/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React from 'react';
import ProgressBarWidget from '../../shared/ProgressBar/ProgressBarWidget';
import { IAggregationData } from '../../shared/ProgressBar/IProgressBarWidget';

interface ISiteEnergyUsageComponentProps {
  unit: string;
  category: string;
  aggregationData: IAggregationData;
}

const VirtualMeterEnergyUsageComponent = (
  props: ISiteEnergyUsageComponentProps
) => {
  const { unit, category, aggregationData } = props;

  return (
    <ProgressBarWidget
      unit={unit}
      category={category}
      aggregationData={aggregationData}
      isProgressBarForEnergy={true}
    />
  );
};

export default VirtualMeterEnergyUsageComponent;
